<template>
    <div class="head">
        <div class="title">
            <h1 @click="$router.push('/')">数字化跨境运营虚拟仿真实验系统v1.0</h1>
            <div class="user">
                <div class="user-item">
                    <i class="iconfont icon-yonghu"></i>
                    <span :title="$store.state.student.realName">{{$store.state.student.realName}}</span>
                </div>
                <div class="user-item">
                    <i class="iconfont icon-banji"></i>
                    <span :title="$store.state.student.className">{{$store.state.student.className}}</span>
                </div>
                <div class="user-item logout" @click="logout">
                    <i class="iconfont icon-dengchu"></i>
                    <span>退出</span>
                </div>
            </div>
        </div>
        <div class="progress-bar" v-if="list">
            <div class="bar">
                <div class="item-wrap" v-for="(item,index) in list.step" :key="index">
                    <div class="item" :class="`item_${index+1} ${step==index?'active':''}`"
                         @click="step==index?()=>{} : $router.push(`/experiment_${index}_0`)">
                        {{item.name}}
                    </div>
                    <div class="icon">
                        <img src="./../../assets/images/bar_item_arrow.png" alt="">
                    </div>
                </div>
            </div>
            <slot name="btn">
                <div class="home">
                    <a href="javascript:;" @click="$router.push({path:'/history'})" class="nav">历史实验</a>
                    <a href="javascript:;" @click="$router.push({path:'/'})" class="nav index">首页</a>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Bar",
        props: {
            list: [Object],
            step: [Number, String],
            step_: [Number, String]
        },
        methods: {
            logout() {
                this.$axios.get('/login/logout').then(res => {
                    this.$router.push('/tologin')
                })
            },
            beforeEnter: function (el) {
                el.style.opacity = 0;
                el.style.width = 0
                el.style.overflow = 'hidden'
            },
            enter: function (el, done) {
                Velocity(el, {opacity: 1, width: '700px', overflow: 'initial'}, {duration: 3000})

            }
        }
    }
</script>

<style scoped lang="scss">
    $rem: 0.01rem;
    .head {
        div.title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            > h1 {
                font-size: 44*$rem;
                font-weight: bolder;
                cursor: pointer;
            }

            > div.user {

                height: 40*$rem;
                display: flex;
                align-items: center;
                background: url("./../../assets/images/user.png");
                background-size: 100% 100%;
                color: #25FCFF;
                padding: 0 30*$rem;
                box-sizing: border-box;

                > div.user-item {
                    display: flex;
                    align-items: center;
                    margin-right: 10*$rem;

                    &.logout:hover {
                        cursor: pointer;
                        color: #ff8700;
                    }

                    i {
                        padding: 0 10*$rem;
                    }

                    span {
                        max-width: 110*$rem;
                        height: 24*$rem;
                        line-height: 24*$rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                }
            }
        }

        div.progress-bar {
            display: flex;
            justify-content: space-between;
            font-size: 18*$rem;
            font-family: "SimHei", serif;
            margin-bottom: 16*$rem;
            margin-top: 43*$rem;

            div.bar {
                display: flex;
                background: #012154;
                height: 44*$rem;
                position: relative;
                box-sizing: border-box;
                background-image: url("./../../assets/images/bg_right.png");
                background-size: 100% 100%;
                padding: 0 16*$rem;

                div.item-wrap {
                    display: flex;

                    &:last-child > div.icon {
                        display: none;
                    }

                    > div.item {
                        cursor: pointer;
                        height: 44*$rem;
                        line-height: 44*$rem;
                        padding: 0 16*$rem;
                        box-sizing: border-box;
                        color: #FFFFFF;
                        position: relative;
                        transition: all 0.6s ease-in-out;
                        &.active{
                            color: #FF8700;
                            &:before {
                                content: '';
                                position: absolute;
                                bottom: 5*$rem;
                                left: 50%;
                                transform: translateX(-50%);
                                border-left: 6px solid transparent;
                                border-right: 6px solid transparent;
                                border-top: 6px solid transparent;
                                border-bottom: 6px solid #FF8700;
                                transition: all 1s linear;
                            }
                        }

                    }

                    > div.icon {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        span {
                            width: 4*$rem;
                            height: 4*$rem;
                            background: #25FCFF;
                            margin-right: 8*$rem;

                            &:first-child {
                                margin-left: 8*$rem;
                            }
                        }
                    }
                }
            }

            div.home {
                display: inherit;

                a.nav {
                    text-align: center;
                    line-height: 42*$rem;
                    color: #FFFFFF;
                    text-decoration: none;
                    display: block;
                    width: 162*$rem;
                    height: 42*$rem;
                    background: url("../../assets/images/next_button_bg.png");
                    background-size: cover;
                    margin-right: 10*$rem;
                }

                a.nav.index {
                    background-image: url("../../assets/images/back_home_bg.png");
                    margin-right: 0;
                }
            }
        }
    }
</style>
